import { Map, List } from "immutable";

import {
  JOURNAL_PARTNER_TAG_ADMIN_LIST_REQUEST,
  JOURNAL_PARTNER_TAG_ADMIN_LIST_SUCCESS,
  JOURNAL_PARTNER_TAG_ADMIN_LIST_FAILURE,
  JOURNAL_PARTNER_TAG_ADMIN_READ_REQUEST,
  JOURNAL_PARTNER_TAG_ADMIN_READ_SUCCESS,
  JOURNAL_PARTNER_TAG_ADMIN_READ_FAILURE,
  JOURNAL_PARTNER_TAG_ADMIN_UPDATE_REQUEST,
  JOURNAL_PARTNER_TAG_ADMIN_UPDATE_SUCCESS,
  JOURNAL_PARTNER_TAG_ADMIN_UPDATE_FAILURE,
  JOURNAL_PARTNER_TAG_ADMIN_CREATE_REQUEST,
  JOURNAL_PARTNER_TAG_ADMIN_CREATE_SUCCESS,
  JOURNAL_PARTNER_TAG_ADMIN_CREATE_FAILURE,
  JOURNAL_PARTNER_TAG_ADMIN_DELETE_REQUEST,
  JOURNAL_PARTNER_TAG_ADMIN_DELETE_SUCCESS,
  JOURNAL_PARTNER_TAG_ADMIN_DELETE_FAILURE,
  JOURNAL_PARTNER_TAG_ADMIN_FORM_DESTROY,
} from "./actions";
import Logger from "../../../lib/Logger";

export default function journalPartnerTagsAdmin(
  state = Map({
    isLoading: false,
    arePartnerTagsAdminLoading: false,
    pages: {},
  }),
  action
) {
  Logger.log(
    "debug",
    `[journalPartnerTagsAdmin.reducers] journalPartnerTagsAdmin(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case JOURNAL_PARTNER_TAG_ADMIN_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case JOURNAL_PARTNER_TAG_ADMIN_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ["pages", action.order, action.limit, action.page],
          List(action.result)
        );

    case JOURNAL_PARTNER_TAG_ADMIN_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case JOURNAL_PARTNER_TAG_ADMIN_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case JOURNAL_PARTNER_TAG_ADMIN_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case JOURNAL_PARTNER_TAG_ADMIN_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case JOURNAL_PARTNER_TAG_ADMIN_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case JOURNAL_PARTNER_TAG_ADMIN_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case JOURNAL_PARTNER_TAG_ADMIN_UPDATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(["form", "errors"], action.error);

    case JOURNAL_PARTNER_TAG_ADMIN_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case JOURNAL_PARTNER_TAG_ADMIN_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case JOURNAL_PARTNER_TAG_ADMIN_CREATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(["form", "errors"], action.error);

    case JOURNAL_PARTNER_TAG_ADMIN_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case JOURNAL_PARTNER_TAG_ADMIN_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case JOURNAL_PARTNER_TAG_ADMIN_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case JOURNAL_PARTNER_TAG_ADMIN_FORM_DESTROY:
      return state
        .mergeDeep({
          form: null,
        })
        .set("form", action.form);

    default:
      return state;
  }
}

Logger.log("silly", `journalPartnerTagsAdmin.reducers loaded.`);
